export default "__VITE_ASSET__xI_3HiCL__"